import { z } from 'zod'
import { oc } from '@orpc/contract'

// The caller's own choice of which task-assignment alerts they receive, per board
// (PD-1809). Only email and SMS are switchable — the in-app notification always
// fires. A board the caller never set reports both on (the default).
const notifyPrefsSchema = z.object({ email: z.boolean(), sms: z.boolean() })

// Every live board in the caller's org with the caller's choice for it, so one
// panel can set them all.
export const boardNotifyPrefsList = oc
  .route({ method: 'GET', path: '/v2/board-notify-prefs' })
  .input(z.object({}).optional())
  .output(
    z.object({
      boards: z.array(notifyPrefsSchema.extend({ boardId: z.string(), boardName: z.string() })),
    }),
  )

export const boardNotifyPrefsSet = oc
  .route({ method: 'PUT', path: '/v2/boards/{boardId}/notify-prefs' })
  .input(notifyPrefsSchema.extend({ boardId: z.string() }))
  .output(notifyPrefsSchema)
